/**
 * src/data/videos.js: danh sách video ngắn (YouTube Shorts) hiển thị trên site.
 *
 * Nguồn chính là Firestore `videos` (sửa ở /admin/video), được kéo về
 * videosRemote.js lúc build (scripts/fetch-videos.mjs, GitHub Action chạy mỗi
 * 2 giờ). VIDEOS_CODE chỉ để có sẵn vài video trước khi nhập trên trang quản
 * trị; bản trên Firestore cùng mã thay trọn bản ở đây.
 */
import { gopVideo, videoChoTrang } from '@shared/video.js';
import REMOTE from './videosRemote.js';
import RSS from './videosRss.js';

// Kênh YouTube fundraising.vn, 6 video đầu (ngày đăng theo giờ Việt Nam).
export const VIDEOS_CODE = [
  {
    id: '6K038LnRcCs', tieuDe: 'Founder còn 45% sau 3 vòng gọi vốn: thiệt hay lợi?', ngayDang: '2026-10-27', thoiLuong: 40,
    moTa: 'Pha loãng cổ phần là gì, và vì sao tỷ lệ giảm mà giá trị phần của nhóm sáng lập vẫn tăng khi mỗi vòng bán ở định giá cao hơn.',
    loat: 'Thuật ngữ trong 60 giây', ganVao: ['/thuat-ngu/pha-loang-co-phan', '/cong-cu/bang-co-phan-va-pha-loang'], status: 'PUBLISHED',
  },
  {
    id: 'yR5qJSm4Eqc', tieuDe: 'Còn 560 triệu, công ty sống được mấy tháng? Runway là gì', ngayDang: '2026-10-27', thoiLuong: 40,
    moTa: 'Runway bằng tiền mặt chia cho net burn. Vì sao nên bắt đầu gọi vốn khi còn 9 đến 12 tháng runway.',
    loat: 'Thuật ngữ trong 60 giây', ganVao: ['/thuat-ngu/runway-la-gi', '/thuat-ngu/burn-rate', '/cong-cu/tinh-runway'], status: 'PUBLISHED',
  },
  {
    id: 'iXLQCBMscsM', tieuDe: 'Đồng sáng lập nghỉ sau 6 tháng có giữ cổ phần không? Vesting là gì', ngayDang: '2026-10-26', thoiLuong: 38,
    moTa: 'Lịch vesting phổ biến 4 năm, cliff 12 tháng: nghỉ trước cliff thì không giữ gì, đủ 12 tháng nhận ngay 25%.',
    loat: 'Thuật ngữ trong 60 giây', ganVao: ['/thuat-ngu/vesting-la-gi', '/thuat-ngu/cliff-vesting', '/cong-cu/chia-co-phan-dong-sang-lap'], status: 'PUBLISHED',
  },
  {
    id: 'vOLwDBRZZJs', tieuDe: 'Gọi 2 tỷ ở định giá 8 tỷ: nhà đầu tư nhận 20% hay 25%?', ngayDang: '2026-10-26', thoiLuong: 38,
    moTa: 'Cùng con số định giá, pre-money hay post-money cho ra tỷ lệ cổ phần khác hẳn. Hỏi rõ trước khi ký term sheet.',
    loat: 'Thuật ngữ trong 60 giây', ganVao: ['/thuat-ngu/pre-money-post-money', '/cong-cu/mo-phong-vong-goi-von'], status: 'PUBLISHED',
  },
  {
    id: 'C3nZmFQ3Hvc', tieuDe: '30 giây đầu của pitch deck, nhà đầu tư nhìn gì?', ngayDang: '2026-10-26', thoiLuong: 45,
    moTa: 'Năm điều cần soát trước khi gửi deck: vấn đề, giải pháp, traction, thị trường và đội ngũ.',
    loat: 'Mẹo gọi vốn', ganVao: ['/cong-cu/pitch-deck-10-slide', '/thuat-ngu/pitch-deck-la-gi', '/playbook/pitch-deck-tot-va-chua-tot'], status: 'PUBLISHED',
  },
  {
    id: 'EfEmbMvS8_M', tieuDe: 'Gọi 200 triệu USD ở vòng seed? Đừng lấy đó làm thước đo', ngayDang: '2026-10-26', thoiLuong: 36,
    moTa: 'Vòng seed khổng lồ là ngoại lệ. Ở Việt Nam, vòng pre-Series A trung vị năm 2023 chỉ khoảng 0,5 triệu USD; hãy tính số vốn theo cột mốc của bạn.',
    loat: 'Mẹo gọi vốn', ganVao: ['/thuat-ngu/vong-seed', '/playbook/tu-pre-series-a-len-series-a-o-viet-nam', '/cong-cu/tinh-runway'], status: 'PUBLISHED',
  },
];

// Thứ tự ưu tiên: RSS kênh (tự động) < bản trong code < Firestore (/admin/video).
export const VIDEOS = gopVideo([...RSS, ...VIDEOS_CODE], REMOTE);

export const videoCuaTrang = (path) => videoChoTrang(VIDEOS, path);
